var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5875 26.9996H6.00001C5.73479 26.9996 5.48044 26.8943 5.2929 26.7068C5.10536 26.5192 5.00001 26.2649 5.00001 25.9996V20.4121C4.99955 20.2823 5.02471 20.1536 5.07404 20.0335C5.12338 19.9134 5.19591 19.8042 5.28751 19.7121L20.2875 4.71215C20.3806 4.61766 20.4915 4.54263 20.6138 4.49141C20.7361 4.44019 20.8674 4.41382 21 4.41382C21.1326 4.41382 21.2639 4.44019 21.3862 4.49141C21.5085 4.54263 21.6195 4.61766 21.7125 4.71215L27.2875 10.2871C27.382 10.3802 27.457 10.4911 27.5082 10.6134C27.5595 10.7357 27.5858 10.867 27.5858 10.9996C27.5858 11.1323 27.5595 11.2635 27.5082 11.3859C27.457 11.5082 27.382 11.6191 27.2875 11.7121L12.2875 26.7121C12.1955 26.8037 12.0863 26.8763 11.9661 26.9256C11.846 26.9749 11.7174 27.0001 11.5875 26.9996V26.9996Z",
    stroke: "#1480C1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 7.99976L24 14.9998",
    stroke: "#1480C1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.61c6ec50631818f208253ae860fdade8.svg";
export { ForwardRef as ReactComponent };